module.exports = __webpack_public_path__ + "img/0120.00fb9991.png";